import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {AbstractControl, ControlContainer, FormGroupDirective, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ValidationMessageComponent} from '../../../structure/validation-message/validation-message.component';
import {appendErrorInfos, ValidationMessage} from '../../../structure/validation-message/validation-message';
import {I18NextPipe} from '@kokos-i18next';
import {WarningMessageComponent} from "../../../structure/warning-message/warning-message.component";

@Component({
    selector: 'pf-input',
    imports: [
        ReactiveFormsModule,
        CommonModule,
        ValidationMessageComponent,
        I18NextPipe,
        WarningMessageComponent
    ],
    templateUrl: './input.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent implements OnInit {
    @Input() name = 'name';
    @Input() label = 'label';
    @Input() controlName!: string;
    @Input() maxLetters = 50;
    @Input() required = true;
    @Input() validate = false;
    @Input() placeholder = '';
    @Input() validationMessages: ValidationMessage[] = [];

    control!: AbstractControl;

    private readonly parentFormGroup = inject(FormGroupDirective);

    textTooLongOnPaste = false;


    ngOnInit(): void {
        this.control = this.parentFormGroup.form.get(this.controlName)!;
    }

    get currentLength(): number {
        return this.control?.value ? (this.control.value as string).length : 0;
    }

    hasAlerts():boolean{
        return this.hasErrors() || this.hasWarnings();
    }

    hasErrors(): boolean {
        return this.validate && !!this.control?.errors;
    }

    hasWarnings(): boolean {
        return this.textTooLongOnPaste;
    }

    getAlertClass(): string | null {
        if (this.hasErrors()) {
            return 'ba-error';
        }
        if (this.hasWarnings()) {
            return 'ba-warning';
        }
        return null;
    }

    inputLostFocus(): void {
        const v = this.control?.value as string | null | undefined;
        if (typeof v === 'string') {
            this.control.setValue(v.trim());
        }
    }

    getRelevantErrorMessage(): ValidationMessage[] {
        const errors = this.control?.errors;
        if (!errors) return [];
        return this.validationMessages
            .filter(vm => vm.key in errors)
            .map(vm => appendErrorInfos(vm, errors));
    }

    onBeforeInput(e: InputEvent): void {
        if (e.inputType === 'insertFromPaste') {
            const pasted = e.data ?? '';
            this.textTooLongOnPaste = pasted.length > this.maxLetters;
            return;
        }
        this.textTooLongOnPaste = false;
    }

}